import { ElementType } from 'react';
import {
  Code as CodeIcon,
  Favorite as FavoriteIcon,
  Flight as FlightIcon,
  MenuBook as MenuBookIcon,
  Movie as MovieIcon,
  MusicNote as MusicNoteIcon,
  Pets as PetsIcon,
  Restaurant as RestaurantIcon,
  School as SchoolIcon,
  Science as ScienceIcon,
  SportsEsports as SportsEsportsIcon,
  Work as WorkIcon,
} from '@mui/icons-material';

/**
 * Icon catalog offered in the "Створити словник" modal. Order here doubles as
 * the visual order in the 6-column picker grid. Stored values are the keys
 * the mock data references; resolving to a component is centralized so any
 * place that renders a custom dictionary uses the same mapping.
 */
export const CUSTOM_ICON_CHOICES: { key: string; Icon: ElementType }[] = [
  { key: 'menu_book', Icon: MenuBookIcon },
  { key: 'work', Icon: WorkIcon },
  { key: 'code', Icon: CodeIcon },
  { key: 'flight', Icon: FlightIcon },
  { key: 'movie', Icon: MovieIcon },
  { key: 'school', Icon: SchoolIcon },
  { key: 'restaurant', Icon: RestaurantIcon },
  { key: 'sports_esports', Icon: SportsEsportsIcon },
  { key: 'favorite', Icon: FavoriteIcon },
  { key: 'science', Icon: ScienceIcon },
  { key: 'music_note', Icon: MusicNoteIcon },
  { key: 'pets', Icon: PetsIcon },
];

const CUSTOM_ICON_MAP: Record<string, ElementType> = CUSTOM_ICON_CHOICES.reduce(
  (acc, { key, Icon }) => ({ ...acc, [key]: Icon }),
  {},
);

export const resolveCustomIcon = (key: string): ElementType =>
  CUSTOM_ICON_MAP[key] || WorkIcon;

export const CUSTOM_COLOR_CHOICES = [
  '#3B2C93',
  '#488BFF',
  '#9B7CFF',
  '#27CCBC',
  '#5FA56F',
  '#F2B14C',
  '#FF7043',
  '#E2330A',
];
